import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useLevelBonusInfoStore = defineStore('levelBonusInfo', () => {
  // State
  const status = ref('idle')
  const levelBonusInfo = ref({})
  const error = ref(null)

  // Getters
  const getStatus = computed(() => status.value)
  const getLevelBonusInfo = computed(() => levelBonusInfo.value)
  const getError = computed(() => error.value)
  const loading = computed(() => ['fetching', 'updating'].includes(status.value))
  const isFetching = computed(() => status.value === 'fetching')
  const isUpdating = computed(() => status.value === 'updating')

  // Actions
  function setStatus(data) {
    status.value = data
  }

  function setError(data) {
    error.value = data
  }

  function setLevelBonusInfo(data) {
    levelBonusInfo.value = data
  }

  return {
    // State
    status,
    levelBonusInfo,
    error,

    // Getters
    getStatus,
    getError,
    loading,
    isFetching,
    isUpdating,
    getLevelBonusInfo,

    // Actions
    setStatus,
    setLevelBonusInfo,
    setError,
  }
})